import React, { useEffect } from "react";
import UserDataGrid from "../../components/UserDataGrid";
import { useSelector } from "react-redux";

const UserPage = () => {
  useEffect(() => {
    document.title = "TransferMyRx::Manage Users";
    const pageTitle = document.getElementById("page-title-text");
    if (pageTitle) {
      pageTitle.innerText = "Manage Users";
    }
  }, []);
  const currentUser = useSelector((state) => state.currentUser);
  console.log(currentUser);
  return (
    currentUser?.user?.roleId === 1 || currentUser?.user?.roleId === 2 ? <UserDataGrid /> : <>No Access</>
  );
};

export default UserPage;
